module.exports = __webpack_public_path__ + "static/media/facebook.c509a4c4.svg";


//////////////////
// WEBPACK FOOTER
// ./src/components/_minha-central/Footer/social-icons/facebook.svg
// module id = 1436
// module chunks = 0